import { AfterContentChecked, ChangeDetectorRef, Component, ComponentFactoryResolver, EventEmitter, HostListener, Input, OnInit, Output, Type, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationExtras, NavigationStart, Router } from '@angular/router';

import { alert, confirm, custom } from 'devextreme/ui/dialog';

import { OverlaySideFormService } from '../../../components/shared/overlay-side-form/overlay-side-form.service';
import { AnagraficaService } from '../../../services/anagrafica.service';
import { ComponentService } from '../../../services/component.service';
import { FormsTemplateService } from '../../../services/forms-template.service';
import { NicaMenuService } from '../../../services/nica-menu.service';
import { RentriService } from '../../../services/rentri.service';
import { NicaMapsComponent } from '../../../widgets/nica-maps/nica-maps.component';


import { NicaMaster } from '../../../components/nica-master-component/nica-master.component';
import { NicaFiltroComponent } from '../../../components/shared/nica-filtro/nica-filtro.component';
import notify from 'devextreme/ui/notify';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { NewNicaFormComponent } from '../../../components/nica-form/new-nica-form.component';


@Component({
  selector: 'app-ana-unita-locali',
  templateUrl: './ana-unita-locali.component.html',
  styleUrls: ['./ana-unita-locali.component.css', '../../ana-soggetto/ana-soggetto.component.css']
})
export class AnaUnitaLocaliComponent extends NicaMaster implements OnInit, AfterContentChecked {

  @Input() idSoggetto: {};
  @Input() itemData
  @Output() onAllEvent: EventEmitter<any> = new EventEmitter<any>();
  apiset: string;
  SubjectCall: string;
  filter: string;
  datiFormulario: any[]
  cssClass: string = ''
  nsAzienda: boolean;

  //Props per Filtri Avanzatis
  filterTemplateKey?: string = 'unitaLocaliFiltri';
  pannelloFiltriAvanzatiVisibile: boolean = false;
  @ViewChild('nicaFiltroUnitaLocali', { static: false }) nicaFiltroUnitaLocali: NicaFiltroComponent;
  @ViewChild('formAnagrafica', { static: false }) formAnagrafica: NewNicaFormComponent;

  constructor(
    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public http: HttpClient,
    private changeDetector: ChangeDetectorRef

  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,

    );
  }



  ngOnInit() {

    this.filterGrid = ''


    if (this.itemData) {
      this.currentTabId = this.itemData[0].currentTabId,
        this.currentTabName = this.itemData[0].componentName
      this.setGlobalVariableFromParams(this.itemData[0])

      this.setFiltroOnInit();

    } else {

      this.activatedroute.queryParams
        .subscribe(params => {
          this.currentTabId = params.currentTabId,
            this.currentTabName = params.currentTabName

          this.showToolBar = false//Per ora ...

          this.setGlobalVariableFromParams(params);

          console.warn('PARAMSSSS', params)

          const parsedData = JSON.parse(params.filter);
          this.nsAzienda = parsedData.nsAzienda;


          if (params.service !== 'sede') {

            this.isAdvancedXlsExportAvailable = false;
            this.allowedAdvancedFilter = false;


          }
          else {
            this.isAdvancedXlsExportAvailable = true;
            this.allowedAdvancedFilter = true;
            this.setFiltroOnInit();
          }


        });

    }





    if (this.SubjectCall == 'sede' && this.template == 'grid') {



      this.pulsantiOpzionaliSede = [

        {
          location: 'before',
          cssClass: 'filter-sede-title toolbar-label',
          isTemplateText: true,
          options: {
            icon: '',
            text: "Filtra l'elenco per tipo attività:",
            class: 'form-control-plaintext',
            stylingMode: 'text',

          }
        },
        {
          location: 'before',
          cssClass: 'filter-sede',
          options: {
            icon: '',
            text: 'Produttore',
            class: 'badge bg-produttore',
            stylingMode: 'text',
            index: 1

          }
        },
        {
          location: 'before',
          cssClass: 'filter-sede',
          options: {
            icon: '',
            text: 'Trasportatore',
            class: 'badge bg-trasportatore',
            stylingMode: 'text',
            index: 2

          }
        },
        {
          location: 'before',
          cssClass: 'filter-sede',
          options: {
            icon: '',
            text: 'Destinatario',
            class: 'badge bg-destinatario',
            stylingMode: 'text',
            index: 3
          }
        },
        {
          location: 'before',
          cssClass: 'filter-sede',
          options: {
            icon: '',
            text: 'Intermediario',
            class: 'badge bg-intermediario',
            stylingMode: 'text',
            index: 4
          }
        },
        {
          location: 'before',
          cssClass: 'filter-sede',
          options: {
            icon: '',
            text: 'Elimina filtro attivo',
            class: 'badge bg-clear-filter',
            stylingMode: 'text',
            index: 5,

          }
        },
      ]
    }



  }

  ngAfterContentChecked(): void {
    if (!this.nsAzienda && this.formAnagrafica) this.formAnagrafica.itemOption('datiUL.idSedeRentri', 'disabled', true)
    this.changeDetector.detectChanges();

  }

  setGlobalVariable(itemData) {

    this.apiset = itemData[0].apiset;
    this.id = itemData[0].id;
    this.queryString = itemData[0].queryString
    this.rowData = itemData[0].dati
    this.template = itemData[0].template
    this.masterKey = itemData[0].masterKey
    this.type = itemData[0].tipo
    this.SubjectCall = itemData[0].SubjectCall;
    this.InviaA = itemData[0].inviaA;
    this.toolbarComponentFilter = itemData[0].toolbarComponent

  }


  setFiltroOnInit() {

    if (!this.allowedAdvancedFilter) {
      return
    }
    let filtriOBJ: Object = JSON.parse(localStorage.getItem('Filtri'));


    if (filtriOBJ && filtriOBJ['unitaLocaliFiltri']) {

      if (filtriOBJ[this.filterTemplateKey].queryString.length > 0) {


        //filtriOBJ[this.filterTemplateKey].queryString = !filtriOBJ[this.filterTemplateKey].queryString.includes('=') ? '' :  filtriOBJ[this.filterTemplateKey].queryString;

        //this.filterGrid += filtriOBJ[this.filterTemplateKey].queryString;

        if (this.filterGrid.toLowerCase().endsWith('asc') || this.filterGrid.toLowerCase().endsWith('desc'))
          this.filterGrid += '&' + filtriOBJ[this.filterTemplateKey].queryString.replace(/[?]/g, '');  //this.filterGrid.split('?')[0];
        else
          this.filterGrid += '?' + filtriOBJ[this.filterTemplateKey].queryString;  //this.filterGrid.split('?')[0];


        setTimeout(
          () => {

            for (let i = 0; i < document.getElementsByClassName('dx-icon export icon-filter').length; i++) {

              if ((document.getElementsByClassName('dx-icon export icon-filter').item(i) as HTMLElement).parentElement.parentElement.id == 'bottoneFiltroToolbar') {

                if (filtriOBJ[this.filterTemplateKey].queryString.length > 0)
                  (document.getElementsByClassName('dx-icon export icon-filter').item(i) as HTMLElement).style.color = '#edcd5f';

                break;
              }

            }

          }, 500
        );

        this.nicaAnagrafica.griglia.instance.refresh();


      }

    }
  }

  optionalButtonClickToolBar(event) {
    console.log('optionalButtonClickToolBar', event);


    if (event == "resettaFiltro") {
      this.resettaFiltroApplicato(this.filterTemplateKey)
    }

    if (event == "pannelloFiltriAvanzatiVisibile") {
      //console.warn(event);

      let instanceData = {
        filtroKeySessionStorage: 'unitaLocaliFiltri',
        nomeTemplate: 'unitaLocaliFiltri',
        captionHidden: true,
        nColForm: '2',
        helpDoc: 'unitaLocaliFiltri.html'
      }
      let guid = this.openComponentInPopUP('NicaFiltroComponent', [], instanceData, '1450', 'Filtri Avanzati', false, true);

      this.userComponentService.outputComponent.subscribe(currentOutput => {
        console.log('Ricevuto evento:', currentOutput);
        // serve per il pulsante annulla
        if (currentOutput.name == 'return' && currentOutput.guid == guid) {
          this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)
          return
        }

        if (currentOutput.name == 'resettaFiltro' && currentOutput.guid == guid) {
          this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)
          this.resettaFiltroApplicato('unitaLocaliFiltri')
          return
        }
        if (currentOutput.name == 'queryOk' && currentOutput.guid == guid) {
          console.log('Applicazione del filtro con:', currentOutput);
          this.onFilterQueryStringEmitted(currentOutput.queryString);
        } else {
          console.log('Nessun valore di filtro ricevuto.');
        }
      });

      setTimeout(() => {
        if (!this.nicaFiltroUnitaLocali)
          return;
        if (!this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData['sD_Stato']) {
          let editor = this.nicaFiltroUnitaLocali.filtroForm.formEdit.instance.getEditor('sD_Stato');
          editor.option('value', "IT");
        }
      }, 500);


    }



  }



  formItemsEvetUL(e) {

    console.log('formItemsEvetUL--->', e)
    const formData = this.formAnagrafica.dataSet.formData

    if (e.name == 'onValueChanged') {

      if (e.campo.dataField == "tipoTrasporto") {
        const tipoTrasporto = this.formAnagrafica.dataSet.tipoTrasporto;

        if (typeof tipoTrasporto == 'number') {
          this.formAnagrafica.formRefreshInputData('tipoTrasporto', tipoTrasporto.toString())
        }

      }


      // if (e.campo.dataField == 'comune') {

      //   this.formAnagrafica.formRefreshInputData('stato', 'IT');

      // }

      if (e.campo.dataField == "siglaProvincia") {
        //this.formAnagrafica.formRefreshInputData('dataChiusuraImpiantoMobile', 'IT');
      }

      if (e.campo.dataField == 'stato') {
        if (e.value != 'IT') {
          e.masterComponent.itemOption('datiUL.comune', 'validationRules', null)
          e.masterComponent.itemOption('datiUL.siglaProvincia', 'validationRules', null);
          e.masterComponent.itemOption('datiUL.cap', 'validationRules', null);

          this.formAnagrafica.formRefreshInputData('istatComune', null);
          this.formAnagrafica.formRefreshInputData('siglaProvincia', null);
          // this.formAnagrafica.formRefreshInputData('cap', null);
          e.masterComponent.itemOption('datiUL.siglaProvincia', 'disabled', true);
          e.masterComponent.itemOption('datiUL.istatComune', 'disabled', true);

        } else {


          let validationRules = [{
            type: 'required',
            message: 'Campo Obbligatorio'
          }]

          e.masterComponent.itemOption('datiUL.comune', 'validationRules', validationRules)
          e.masterComponent.itemOption('datiUL.siglaProvincia', 'validationRules', validationRules);
          e.masterComponent.itemOption('datiUL.cap', 'validationRules', validationRules);
          e.masterComponent.itemOption('datiUL.comune', 'readOnly', true)
          e.masterComponent.itemOption('datiUL.siglaProvincia', 'disabled', false);
          e.masterComponent.itemOption('datiUL.istatComune', 'disabled', false);


        }
        this.changeDetector.detectChanges()
      }


      if (e.campo.dataField == 'isSmaltitore' && !this.filterID['nsAzienda']) {

        e.masterComponent.itemOption('datiUL.numeroIscrizioneAlbo', 'disabled', e.value);
        e.masterComponent.itemOption('datiUL.protocolloAlbo', 'disabled', e.value);
        e.masterComponent.itemOption('datiUL.dataIscrizioneAlbo', 'disabled', e.value);

      }

      if (e.campo.dataField == 'isSmaltitore' && this.filterID['nsAzienda']) {

        this.formAnagrafica.formRefreshInputData('isProduttore', e.value)

      }
      if (e.campo.dataField == 'isSmaltitore') {
        this.formAnagrafica.formRefreshInputData('isDestinatario', e.value)
      }

      if (e.campo.dataField == "isImpiantoMobile") {
        if (e.value) {
          e.masterComponent.itemOption('datiUL.dataChiusuraImpiantoMobile', 'disabled', false);

        } else {
          e.masterComponent.itemOption('datiUL.dataChiusuraImpiantoMobile', 'disabled', true);
          this.formAnagrafica.formRefreshInputData('dataChiusuraImpiantoMobile', null);
        }
      }

    }



    if (e.name == 'selectedItemLista') {

      if (e.campo.dataField == 'siglaProvincia') {
        // this.formAnagrafica.formRefreshInputData('stato', 'IT');

        this.anagraficaService.getElenco('Regione', '', '').then(Reg => {
          let returnReg = []
          if (Reg) {
            Reg = Reg['items']
            for (let x in Reg) {
              let arrayProv = Reg[x]['elencoProvincie'].split(',')
              Reg[x]['arrayProv'] = arrayProv
              const resReg = Reg[x]['arrayProv'].filter(prov => prov == e.value)
              if (resReg.length > 0) {
                returnReg.push(Reg[x])
              }

            }

            if (returnReg[0])
              this.formAnagrafica.formRefreshInputData('idRegione', returnReg[0]['id'])
          }
        })

      }
      if (e.campo.dataField == 'stato') {


        if (e.value != 'IT') {
          e.masterComponent.itemOption('datiUL.comune', 'validationRules', null)

          // e.masterComponent.itemOption('datiUL.comune', 'readOnly', false)
          e.masterComponent.itemOption('datiUL.siglaProvincia', 'validationRules', null);
          e.masterComponent.itemOption('datiUL.cap', 'validationRules', null);
          this.formAnagrafica.formRefreshInputData('istatComune', null);
          //e.component.updateData('comune', null)
          this.formAnagrafica.formRefreshInputData('siglaProvincia', null);
          // this.formAnagrafica.formRefreshInputData('cap', null);
          e.masterComponent.itemOption('datiUL.siglaProvincia', 'disabled', true);
          e.masterComponent.itemOption('datiUL.istatComune', 'disabled', true);

        } else {


          let validationRules = [{
            type: 'required',
            message: 'Campo Obbligatorio'
          }]

          this.formAnagrafica.itemOption('datiUL.comune', 'validationRules', validationRules)
          this.formAnagrafica.itemOption('datiUL.siglaProvincia', 'validationRules', validationRules);
          this.formAnagrafica.itemOption('datiUL.cap', 'validationRules', validationRules);
          //this.formAnagrafica.itemOption('datiUL.comune', 'readOnly', true)
          e.masterComponent.itemOption('datiUL.siglaProvincia', 'disabled', false);
          e.masterComponent.itemOption('datiUL.istatComune', 'disabled', false);

          let comune = this.formAnagrafica.dataSet.comune;

          if (comune.includes("'")) {
            comune = comune.replace("'", "")
          }

          // if (comune != '') {
          //   const filter = `?$filter=( descrizione eq '${comune}' )`;
          //   this.anagraficaService.getElenco('comune', '', filter).then(res => {
          //     if (res['items'].length > 0) {
          //       let items = res['items'][0]
          //       this.formAnagrafica.formRefreshInputData('istatComune', items.id);
          //     }
          //   })
          // }

        }
        this.changeDetector.detectChanges()
      }


    }




    if (e.event == 'copiaDatiAzienda') {

      const icon = e.component.option('icon');

      if (icon == 'glyphicon mdi mdi mdi-checkbox-marked') {
        this.formAnagrafica.formRefreshInputData('descrizione', '');
        this.formAnagrafica.formRefreshInputData('indirizzo', '');
        this.formAnagrafica.formRefreshInputData('civico', '');
        this.formAnagrafica.formRefreshInputData('comune', '');
        this.formAnagrafica.formRefreshInputData('istatComune', '');
        this.formAnagrafica.formRefreshInputData('cap', '');
        this.formAnagrafica.formRefreshInputData('siglaProvincia', '');
        this.formAnagrafica.formRefreshInputData('stato', '');

        e.component.option('icon', 'glyphicon mdi mdi-checkbox-blank-outline');
        return
      } else {

        const data = e.data
        let filter = data['idSoggetto']

        this.anagraficaService.getValue('soggetto', filter, '').then(res => {

          this.formAnagrafica.formRefreshInputData('descrizione', res['ragioneSociale']);
          this.formAnagrafica.formRefreshInputData('indirizzo', res['indirizzo']);
          this.formAnagrafica.formRefreshInputData('civico', res['civico']);
          this.formAnagrafica.formRefreshInputData('comune', res['comune']);
          this.formAnagrafica.formRefreshInputData('istatComune', res['istatComune']);
          this.formAnagrafica.formRefreshInputData('cap', res['cap']);
          this.formAnagrafica.formRefreshInputData('siglaProvincia', res['siglaProvincia']);
          this.formAnagrafica.formRefreshInputData('stato', res['stato']);
          this.formAnagrafica.formRefreshInputData('frazione', res['frazione']);

          e.component.option('icon', 'glyphicon mdi mdi mdi-checkbox-marked');
        })
        return
      }


    }





    if (e.name == 'returnButton') {
      e.component.option('text', "Ritorna all'elenco")
    }

  }

  formEventUL(e) {

    if (e.name == 'ottieniCoordinate') {

      let latitudine = this.formAnagrafica.dataSet.latitudine

      if (latitudine < -90 || latitudine > 90) {
        alert('Per la latitudine specificare un numero compreso tra -90 e 90', 'Attenzione');
        return;
      }

      let longitudine = this.formAnagrafica.dataSet.longitudine;

      if (longitudine < -180 || longitudine > 180) {
        alert('Per la longitudine specificare un numero compreso tra -180 e 180', 'Attenzione');
        return;
      }
      let address = ''
      if (!e.data.indirizzo && !e.data.civico && !e.data.cap && !e.data.comune && !e.data.siglaProvincia) {

        return
      } else {
        address = e.data.indirizzo.concat(' ' + e.data.civico) + ',' + e.data.cap + ' ' + e.data.comune + ' ' + e.data.siglaProvincia
      }



      let data = [
        {
          destComponent: 'AnaSoggetto',
          traceMessage: 'ottieniCoordinate',
          dati: (e.data.latidudine && e.data.longitudine) ? { lat: e.data.latidudine, lng: e.data.longitudine, address: address } : address
        }
      ]

      let guid = this.openComponentInPopUP('NicaMapsComponent', data, null, null, "Ottieni Coordinate", false, true)

      this.userComponentService.outputComponent.subscribe(currentOutput => {
        console.log('currentOutput-->', currentOutput)
        if (currentOutput.guid == guid) {

          if (typeof currentOutput.lat() != 'undefined' && typeof currentOutput.lng() != 'undefined') {
            let coordinate = currentOutput;
            this.formAnagrafica.formRefreshInputData('latidudine', "" + coordinate.lat());
            this.formAnagrafica.formRefreshInputData('longitudine', "" + coordinate.lng());
            this.userComponentService.destroyCurrentOpenPopUpByGuid(guid);
          }
        }

      })
      return

    }

    if (e.name == 'copiaDatiAzienda') {

      const icon = e.buttonEvent.button.icon;

      if (icon == 'glyphicon mdi mdi mdi-checkbox-marked') {
        this.formAnagrafica.formRefreshInputData('descrizione', '');
        this.formAnagrafica.formRefreshInputData('indirizzo', '');
        this.formAnagrafica.formRefreshInputData('civico', '');
        this.formAnagrafica.formRefreshInputData('comune', '');
        this.formAnagrafica.formRefreshInputData('istatComune', '');
        this.formAnagrafica.formRefreshInputData('cap', '');
        this.formAnagrafica.formRefreshInputData('siglaProvincia', '');
        this.formAnagrafica.formRefreshInputData('stato', '');

        e.buttonEvent.button.icon = 'glyphicon mdi mdi-checkbox-blank-outline';
        return
      } else {

        const data = e.data
        let filter = data['idSoggetto']

        this.anagraficaService.getValue('soggetto', filter, '').then(res => {

          this.formAnagrafica.formRefreshInputData('descrizione', res['ragioneSociale']);
          this.formAnagrafica.formRefreshInputData('indirizzo', res['indirizzo']);
          this.formAnagrafica.formRefreshInputData('civico', res['civico']);
          this.formAnagrafica.formRefreshInputData('comune', res['comune']);
          this.formAnagrafica.formRefreshInputData('istatComune', res['istatComune']);
          this.formAnagrafica.formRefreshInputData('cap', res['cap']);
          this.formAnagrafica.formRefreshInputData('siglaProvincia', res['siglaProvincia']);
          this.formAnagrafica.formRefreshInputData('stato', res['stato']);
          this.formAnagrafica.formRefreshInputData('frazione', res['frazione']);

          e.buttonEvent.button.icon = 'glyphicon mdi mdi mdi-checkbox-marked'
        })
        return
      }


    }

    if (e.name == 'return') {
      const copyF = this.filterID;


      let dataSet = this.formAnagrafica.dataSet

      // for (let x in dataSet) {
      //   if (x != 'idSoggetto' && x != 'nsAzienda') {
      //     delete this.filterID[x];
      //   }

      // }

      this.formEvent(e)
    }

    if (e.name == 'submittedEditOk' || e.name == 'submittedInsertOk' || e.name == 'return') {
      this.formEvent(e)
    }

    if (e.name == 'formDataInit') {
      this.SetToolbarButtons(this.serviceButtonsArray, e.formData);
    }

    /*****data */
    // if (e.name == 'allineaRentri' && this.id) {
    if (e.name == 'allineaRentri') {

      this.allineaSediRentri(this.id, e.data.idSoggetto)

    }
  }

  async allineaSediRentri(id, idSoggetto) {



    let titleRentri = "Unità locali R.E.N.T.Ri";
    let queryString = `?idSoggetto=${idSoggetto}`;
    //&$filter=(is_sede_legale eq false)
    let instancedDataGrid = {
      service: 'serviceRentriSede',
      api: 'RentriOld/GetElencoSiti',
      queryString: queryString,
      remoteOperation: true,
      rowAlternate: true,

      isEditable: false,
      isEditableNewRow: false,
      isEditableEditRow: false,
      isEditableDeleteRow: false,
      tableHeight: 600,
      tableWidth: 800,
      showFilter: false,
      selectionRowMode: 'single',
      idTable: '2584848484848484848',
      showToolbarTop: false,
      showToolbarBottom: false,
      isSearchable: false,

    }





    let guid = this.openComponentInPopUP('NicaDataGridComponent', [], instancedDataGrid, '800', titleRentri, true, true)


    this.userComponentService.outputComponent.subscribe(currentOutput => {

      if (currentOutput.name == "gridHasInitialized" && currentOutput.guid == guid) {
        //currentOutput.component.refresh()
      }
      if (currentOutput.name == "onRowSelectionChange" && currentOutput.guid == guid) {

        const num_iscr_sito = currentOutput.data.num_iscr_sito

        this.formAnagrafica.formRefreshInputData('idSedeRentri', num_iscr_sito);

        this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)

      }
    })




  }

  formInitializzed(event) {


    this.SetToolbarButtons(this.serviceButtonsArray, event.formData);

    const form = event.component

    if (!this.filterID['nsAzienda']) {
      form.itemOption('allineamentoReentri', 'cssClass', 'd-none')

      form.itemOption('altreConfUl', 'cssClass', 'd-none')

      form.itemOption('datiUL.isImpiantoMobile', 'disabled', true);
      form.itemOption('datiUL.dataChiusuraImpiantoMobile', 'disabled', true)
    }

    console.log('event-->', event)
    if (event.name === "formContentInitializzed") {
      const isImpiantoMobile = event.formData.isImpiantoMobile
      if (isImpiantoMobile) {

        event.component.itemOption('datiUL.dataChiusuraImpiantoMobile', 'disabled', false);
      }
    }


  }



  onAllEventFiltro(ev) {

    if (ev !== 'salva')
      try {

        if (this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData['uL_IdRegione'] && ev.campo.dataField == 'uL_IdRegione') {
          this.nicaFiltroUnitaLocali.filtroForm.formEdit.instance.updateData('uL_SiglaProvincia', undefined);
          this.nicaFiltroUnitaLocali.filtroForm.formEdit.instance.updateData('uL_Comune', undefined);

        }
        if (this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData['uL_Comune'] && ev.campo.dataField == 'uL_Comune') {

          this.nicaFiltroUnitaLocali.filtroForm.formEdit.instance.updateData('uL_SiglaProvincia', undefined);
          this.nicaFiltroUnitaLocali.filtroForm.formEdit.instance.updateData('uL_IdRegione', undefined);
        }
        else if (this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData['uL_SiglaProvincia'] && ev.campo.dataField == 'uL_SiglaProvincia') {

          this.nicaFiltroUnitaLocali.filtroForm.formEdit.instance.updateData('uL_Comune', undefined);
          this.nicaFiltroUnitaLocali.filtroForm.formEdit.instance.updateData('uL_IdRegione', undefined);

        }


        if (this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData['sD_Comune'] && ev.campo.dataField == 'sD_Comune')
          this.nicaFiltroUnitaLocali.filtroForm.formEdit.instance.updateData('sD_SiglaProvincia', undefined);
        else if (this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData['sD_SiglaProvincia'] && ev.campo.dataField == 'sD_SiglaProvincia')
          this.nicaFiltroUnitaLocali.filtroForm.formEdit.instance.updateData('sD_Comune', undefined);
      } catch (ex) {

        console.error('ERRORE', ex);
        //console.warn(ev);
        //console.warn(this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData);

        if (ev.formDataChanged) {
          if (ev.formDataChanged['uL_IdRegione'])
            this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData['uL_IdRegione'] = ev.formDataChanged['uL_IdRegione'];

          if (ev.formDataChanged['sD_Comune'])
            this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData['sD_Comune'] = ev.formDataChanged['sD_Comune'];

          if (ev.formDataChanged['uL_Comune'])
            this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData['uL_Comune'] = ev.formDataChanged['uL_Comune'];


        }
        //this.nicaFiltroUnitaLocali.filtroForm.formEdit.instance.updateData('sD_Comune',ev.formDataChanged['sD_Comune']);

      }

    /*
    if(ev!=='salva' && (this.nomeTemplate == 'unitaLocaliFiltri' || this.nomeTemplate == 'soggettiFiltri'))
    try{
    if(this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData['uL_IdRegione'] && ev.campo.dataField=='uL_IdRegione'){
    
      this.nicaFiltroUnitaLocali.filtroForm.formEdit.instance.updateData('uL_SiglaProvincia',undefined);
      this.nicaFiltroUnitaLocali.filtroForm.formEdit.instance.updateData('uL_Comune',undefined);
    
    
    }
    
      
    
    
    }catch(ex){
    
    //console.error('ERRORE',ex);
    //console.warn(ev);
    //console.warn(this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData);
    
    if(ev.formDataChanged){
    
      if(ev.formDataChanged['sD_Comune'])
        this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData['sD_Comune'] = ev.formDataChanged['sD_Comune'];
    
        if(ev.formDataChanged['uL_Comune'])
        this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData['uL_Comune'] = ev.formDataChanged['uL_Comune'];
    
    
    }
        //this.nicaFiltroUnitaLocali.filtroForm.formEdit.instance.updateData('sD_Comune',ev.formDataChanged['sD_Comune']);
    
    }
    */



    if (this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData['soloUnitaLocaliEstereCheckBox'] !== undefined && ev.component) {

      //console.warn('spipposs',ev);

      if (this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData['soloUnitaLocaliEstereCheckBox'] == true && ev.component) {

        ev.component.itemOption('uL_Stato', 'disabled', false);
        ev.component.getEditor('uL_Stato').option('disabled', false);


      }


      if (this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData['soloUnitaLocaliEstereCheckBox'] == false && ev.component) {

        ev.component.itemOption('uL_Stato', 'disabled', true);
        ev.component.getEditor('uL_Stato').option('disabled', true);


        this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData['uL_Stato'] = undefined;


      }



    }


    if (this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData['soloSoggettiEsteriCheckBox'] !== undefined && ev.component) {

      //console.warn('spipposs',ev);

      if (this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData['soloSoggettiEsteriCheckBox'] == true && ev.component) {

        ev.component.itemOption('sD_Stato', 'disabled', false);
        ev.component.getEditor('sD_Stato').option('disabled', false);


      }


      if (this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData['soloSoggettiEsteriCheckBox'] == false && ev.component) {

        ev.component.itemOption('sD_Stato', 'disabled', true);
        ev.component.getEditor('sD_Stato').option('disabled', true);


        this.nicaFiltroUnitaLocali.filtroForm.formEdit.formData['sD_Stato'] = undefined;


      }



    }

    //console.warn(ev);


    if (ev.name == 'ValueChangedLista') {

      if (ev.campo.dataField == 'uL_Stato') {

        if (!ev.value) {

          ev.component.itemOption('datiPrincipaliSede.uL_SiglaProvincia', 'disabled', false);
          ev.component.getEditor('uL_SiglaProvincia').option('disabled', false);



          ev.component.itemOption('datiPrincipaliSede.sD_Comune', 'disabled', false);
          ev.component.getEditor('uL_Comune').option('disabled', false);



        }
        else if (ev.value.toLowerCase() == 'it') {

          ev.component.itemOption('datiPrincipaliSede.uL_SiglaProvincia', 'disabled', false);
          ev.component.getEditor('uL_SiglaProvincia').option('disabled', false);



          ev.component.itemOption('datiPrincipaliSede.sD_Comune', 'disabled', false);
          ev.component.getEditor('uL_Comune').option('disabled', false);



        }
        else if (ev.value.toLowerCase() !== 'it') {

          ev.component.itemOption('datiPrincipaliSede.uL_SiglaProvincia', 'disabled', true);
          ev.component.getEditor('uL_SiglaProvincia').option('disabled', true);

          this.nicaFiltroUnitaLocali.filtroForm.formEdit.instance.updateData('uL_SiglaProvincia', undefined);

          ev.component.itemOption('datiPrincipaliSede.sD_Comune', 'disabled', true);
          ev.component.getEditor('uL_Comune').option('disabled', true);


          this.nicaFiltroUnitaLocali.filtroForm.formEdit.instance.updateData('uL_Comune', undefined);


        }


      }

      if (ev.campo.dataField == 'sD_Stato') {


        if (!ev.value) {

          ev.component.itemOption('datiPrincipaliSoggetto.sD_SiglaProvincia', 'disabled', false);
          ev.component.getEditor('sD_SiglaProvincia').option('disabled', false);

          ev.component.itemOption('datiPrincipaliSoggetto.sD_Comune', 'disabled', false);
          ev.component.getEditor('sD_Comune').option('disabled', false);



        }
        else if (ev.value.toLowerCase() == 'it') {

          ev.component.itemOption('datiPrincipaliSoggetto.sD_SiglaProvincia', 'disabled', false);
          ev.component.getEditor('sD_SiglaProvincia').option('disabled', false);

          ev.component.itemOption('datiPrincipaliSoggetto.sD_Comune', 'disabled', false);
          ev.component.getEditor('sD_Comune').option('disabled', false);



        }
        else if (ev.value.toLowerCase() !== 'it') {

          ev.component.itemOption('datiPrincipaliSoggetto.sD_SiglaProvincia', 'disabled', true);
          ev.component.getEditor('sD_SiglaProvincia').option('disabled', true);

          this.nicaFiltroUnitaLocali.filtroForm.formEdit.instance.updateData('sD_SiglaProvincia', undefined);


          ev.component.itemOption('datiPrincipaliSoggetto.sD_Comune', 'disabled', true);
          ev.component.getEditor('sD_Comune').option('disabled', true);

          this.nicaFiltroUnitaLocali.filtroForm.formEdit.instance.updateData('sD_Comune', undefined);

        }


      }


      /*
      // SOGGETTO SIGLA PROVINCIA
      if(ev.campo.dataField == 'sD_SiglaProvincia'){
    
        ev.component.itemOption('datiPrincipaliSoggetto.sD_Comune', 'value', undefined);
        ev.component.getEditor('sD_Comune').option('value', undefined);
    
    
        this.filtroForm.formEdit.instance.updateData('sD_Comune',undefined);
      
        
      }
    
      
      // SEDE SIGLA PROVINCIA
      if(ev.campo.dataField == 'uL_SiglaProvincia'){
    
        ev.component.itemOption('datiPrincipaliSede.uL_Comune', 'value', undefined);
        ev.component.getEditor('uL_Comune').option('value', undefined);
    
    
        this.filtroForm.formEdit.instance.updateData('uL_Comune',undefined);
    
        
    
      }
      */
    }


  }

  async onChiusuraAnnullaFiltro(evt) {

    if (this.nicaFiltroUnitaLocali)
      await this.nicaFiltroUnitaLocali.annullaFiltro();


    this.pannelloFiltriAvanzatiVisibile = false;


  }

  onShowing(e) {
    //////console.log('eventooooo',e);

    //this.showEdit = true;
    e.component.content().parentNode.classList.add("bg-grey"); //add class to overlay content
    e.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
    //e.component.content().parentNode.classList.add("popup"); //add class to overlay content
    e.component.content().classList.add("soggetto-form"); //add class to content

    //<div class="dx-item-content dx-box-item-content" style="width: auto; height: auto; display: flex; flex-basis: 0px; flex-grow: 1; flex-direction: column;"></div>
    //soggetto-form
    setTimeout(() => {
      var tt = $(".soggetto-form").find(".dx-item .dx-box-item");
      //var tt=$(".dx-item-content .dx-box-item-content");
      //tt[tt.length-1].remove();
      //console.log("ecco le classi ",tt);

    }, 200);

    //$( ".hello" ).remove();
    /*
    if(this.formEditingPopup !== undefined)
      this.formEditingPopup.visible=true;
    */
  }

  async onFilterQueryStringEmitted(queryString: string) {
    if (!this.nicaAnagrafica.griglia.instance) {
      console.error("Errore: griglia non disponibile.");
      return;
    }

    if (!queryString || queryString.trim().length === 0) {
      console.error("Errore: queryString non definita o vuota.");
      return;
    }

    console.log("QueryString prima del caricamento dei dati:", queryString);
    let filterData = await this.loadFilterData(queryString);
    if (!filterData) {
      console.error("Errore: Nessun dato di filtro ricevuto.");
      return;
    }

    console.log("Dati filtro ricevuti:", filterData);
    const updatedQueryString = this.buildFilterQuery(filterData);
    console.log("QueryString aggiornata:", updatedQueryString);
    this.applyFilterSettings(updatedQueryString);
  }

  private async loadFilterData(queryString: string): Promise<any> {
    console.log('Caricamento dati con queryString:', queryString);
    const response = await this.http.get<any>(`${environment.BASE_API_URL}SoggettoSede/GetAllSoggettiSedi${queryString} and sD_Id eq ${this.filterID.idSoggetto}`).toPromise();
    console.log('Dati ricevuti:', response);
    return response;
  }

  buildFilterQuery(filters): string {
    if (!filters || !filters.items || filters.items.length === 0) {
      console.log('Nessun filtro valido ricevuto');
      return "$filter=Id eq null";
    }

    let query = "$filter=";
    filters.items.forEach(item => {
      Object.keys(item).forEach(key => {
        const value = item[key];
        const modifiedKey = key.startsWith('uL_') ? key.substring(3) : key;

        // Aggiungi solo se la chiave modificata è 'Id'
        if (modifiedKey === 'Id' && typeof value === 'number') {
          query += ` (${modifiedKey} eq ${value}) or`;
        }
      });
    });

    // Rimuovi l'ultimo "and" dalla stringa di query se la query è maggiore di "$filter="
    if (query.length > "$filter=".length) {
      return query.slice(0, -3);
    } else {
      // Se nessun Id è stato aggiunto, restituisci una stringa vuota o un'altra logica appropriata
      console.log('Nessun Id valido per la query');
      return "";
    }
  }


  private applyFilterSettings(queryString: string): void {
    console.log("Applicazione delle impostazioni di filtro");
    if (!queryString || queryString.length === 0) {
      console.error("Errore: queryString non definita o vuota.");
      return;
    }

    this.updateFilterGrid(queryString);
    this.updateFilterIconColors(queryString.length > 0);

    if (!this.nicaAnagrafica || !this.nicaAnagrafica.griglia || !this.nicaAnagrafica.griglia.instance) {
      console.error('Impossibile aggiornare la griglia: componente griglia non disponibile');
      return;
    }

    this.nicaAnagrafica.griglia.instance.refresh();
    this.userComponentService.destroyCurrentOpenPopUp('NicaFiltroComponent');
    this.pannelloFiltriAvanzatiVisibile = false;  // Aggiorna lo stato del pannello dei filtri
  }

  updateFilterGrid(queryString: string): void {
    this.filterGrid = this.filterGrid.split('?')[0] + '?' + queryString;
    localStorage.setItem('Filtri', JSON.stringify({ queryString }));
  }

  updateFilterIconColors(hasQuery: boolean): void {
    const color = hasQuery ? '#edcd5f' : '#023957';
    Array.from(document.getElementsByClassName('dx-icon export icon-filter')).forEach(
      icon => (icon as HTMLElement).style.color = color
    );
  }

  appToolBarEvent(evt) {

    console.warn(evt);
  }

}
